import { z } from "zod";
import { Integer } from "./common.js";
export const ProviderOperatorAccount = z.object({
    cognitoSub: z.string().min(1).max(128), email: z.string().email().max(254),
    role: z.literal("provider_operator"), organizationId: z.string().min(1).max(128), active: z.boolean(),
}).strict().openapi("ProviderOperatorAccount");
export const CreateProviderOperatorAccountRequest = z.object({
    operation: z.literal("create"), operationId: z.string().uuid(),
    organizationId: z.string().min(1).max(128), email: z.string().email().max(254),
}).strict().openapi("CreateProviderOperatorAccountRequest");
export const InviteProviderOperatorAccountRequest = z.object({
    operation: z.literal("invite"), operationId: z.string().uuid(),
    organizationId: z.string().min(1).max(128), cognitoSub: z.string().min(1).max(128),
}).strict().openapi("InviteProviderOperatorAccountRequest");
export const DeactivateProviderOperatorAccountRequest = z.object({
    operation: z.literal("deactivate"), operationId: z.string().uuid(),
    organizationId: z.string().min(1).max(128), cognitoSub: z.string().min(1).max(128),
}).strict().openapi("DeactivateProviderOperatorAccountRequest");
export const ProviderOperatorProvisionRequest = z.discriminatedUnion("operation", [CreateProviderOperatorAccountRequest, InviteProviderOperatorAccountRequest, DeactivateProviderOperatorAccountRequest]).openapi("ProviderOperatorProvisionRequest");
export const ProviderOperatorAccountQuery = z.object({
    organizationId: z.string().min(1).max(128), after: z.string().min(1).max(128).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50).openapi({ format: "int32" }),
}).strict().openapi("ProviderOperatorAccountQuery");
export const ProviderOperatorAccountsResponse = z.object({
    accounts: z.array(ProviderOperatorAccount), nextCursor: z.string().optional(), limit: Integer.min(1).max(100),
}).strict().openapi("ProviderOperatorAccountsResponse");
export const ProviderOperatorProvisionResponse = z.object({
    account: ProviderOperatorAccount, operationId: z.string().uuid(),
    status: z.enum(["created", "invited", "deactivated"]),
}).strict().openapi("ProviderOperatorProvisionResponse");
export const ProviderOperatorOrganizationQuery = z.object({
    search: z.string().min(2).max(100), after: z.string().min(1).max(128).optional(),
}).strict().openapi("ProviderOperatorOrganizationQuery");
export const ProviderOperatorOrganization = z.object({ id: z.string(), brandName: z.string(), active: z.boolean() }).strict().openapi("ProviderOperatorOrganization");
export const ProviderOperatorOrganizationsResponse = z.object({ organizations: z.array(ProviderOperatorOrganization), nextCursor: z.string().optional() }).strict().openapi("ProviderOperatorOrganizationsResponse");
//# sourceMappingURL=provider-operator-provision.js.map